export default "__VITE_ASSET__BetjwWuX__"